import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "@mui/material";
import "./Footer.scss";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MyLocationIcon from "@mui/icons-material/MyLocation";

const Footer = () => {
  return (
    <footer className="footerWrapper">
      <Grid container rowSpacing={3}>
        <Grid
          xs={12}
          display="flex"
          gap="24px"
          alignItems="center"
          justifyContent="center"
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "24px",
              borderBottom: "1px solid #544BAE",
              paddingBottom: "24px",
            }}
          >
            <img src="./images/whitelogo.svg" height="45px" alt="Insurvent" />
            <h6>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
              quae ab illo inventore veritatis et quasi architecto beatae vitae
              dicta sunt explicabo.
            </h6>
          </div>
        </Grid>
        <Grid xs={12} textAlign="center">
          <ul
            style={{
              display: "inline-flex",
              gap: "12px",
              borderBottom: "1px solid #544BAE",
              paddingBottom: "24px",
            }}
          >
            <li className="pr-3">
              <Link>About</Link>
            </li>
            <li className="px-3">
              <Link>Our Team</Link>
            </li>
            <li className="px-3">
              <Link>Travel Policy</Link>
            </li>
            <li className="px-3">
              <Link>Blog</Link>
            </li>
            <li className="px-3">
              <Link>Contact</Link>
            </li>
            <li className="px-3">
              <Link>T&C</Link>
            </li>
            <li className="pl-3">
              <Link>Privacy Policy</Link>
            </li>
          </ul>
        </Grid>
        <Grid xs={12} textAlign="center">
          <ul
            style={{
              display: "inline-flex",
              gap: "24px",
              alignItems: "center",
              borderBottom: "1px solid #544BAE",
              paddingBottom: "24px",
            }}
          >
            <li
              style={{
                display: "inline-flex",
                gap: "4px",
                alignItems: "center",
              }}
            >
              <MyLocationIcon style={{ height: "18px" }} />
              <p style={{ maxWidth: "236px", textAlign: "left" }}>
                4th Floor, plot no. 341, Industrial Area, Phase 9, Mohali,
                Punjab, India - 160062
              </p>
            </li>
            <li
              style={{
                display: "inline-flex",
                gap: "4px",
                alignItems: "center",
              }}
            >
              <LocalPhoneIcon style={{ height: "18px" }} />
              <p>+91 98765 43210</p>
            </li>
            <li
              style={{
                display: "inline-flex",
                gap: "4px",
                alignItems: "center",
              }}
            >
              <EmailIcon style={{ height: "18px" }} />
              <Link
                style={{ fontSize: "12px" }}
                href="mailto:info@insurvent.com"
              >
                info@insurvent.com
              </Link>
            </li>
          </ul>
        </Grid>
        <Grid xs={12} textAlign="center">
          <ul style={{ display: "inline-flex", gap: "12px" }}>
            <li>
              <Link>
                <FacebookIcon />
              </Link>
            </li>
            <li>
              <Link>
                <InstagramIcon />
              </Link>
            </li>
            <li>
              <Link>
                <TwitterIcon />
              </Link>
            </li>
          </ul>
        </Grid>
        <Grid xs={12} textAlign="center">
          <p>© Copyright 2023 Insurvent.com | All Rights Reserved.</p>
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
